import { Box, Paper, Typography } from '@mui/material';
import { Path, useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import type { LocalizedLabel, ReportDefinition } from '../../../types';
import { useDefinitionContext } from '../../contexts/DefinitionContext';
import { LocalizedLabelEditor } from '../LocalizedLabelEditor';
import { HeaderBackgroundColorPicker } from './HeaderBackgroundColorPicker';
import { LogoEditor } from './LogoEditor';

export function BrandingEditor() {
  const { languages } = useDefinitionContext();
  const { control, setValue } = useFormContext<ReportDefinition>();
  const branding = useWatch({ control, name: 'data.branding' });
  const { $t } = useIntl();

  return (
    <Paper sx={{ padding: 2, maxWidth: 'md' }}>
      <Typography variant="h6" gutterBottom mb={2}>
        {$t({
          id: 'audit.reportDefinitions.styleTitle',
          defaultMessage: 'Estilo',
        })}
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        {/* <Box mb={2}>
          <SelectElement
            name="branding.logoPosition"
            label={$t({ id: 'audit.reportDefinitions.logoPosition', defaultMessage: 'Posición del Logo' })}
            options={logoPositionOptions}
            size="small"
            sx={{ width: 300 }}
          />
        </Box> */}

        <Box>
          <Typography variant="subtitle2" gutterBottom>
            {$t({
              id: 'common.text.title',
              defaultMessage: 'Título',
            })}
          </Typography>
          <LocalizedLabelEditor
            value={branding?.title}
            onChange={(value) =>
              setValue('data.branding.title' as Path<ReportDefinition>, value as LocalizedLabel, {
                shouldDirty: true,
              })
            }
            languages={languages}
          />
        </Box>

        <Box>
          <Typography variant="subtitle2" gutterBottom>
            {$t({
              id: 'common.text.subtitle',
              defaultMessage: 'Subtítulo',
            })}
          </Typography>
          <LocalizedLabelEditor
            value={branding?.subtitle}
            onChange={(value) =>
              setValue(
                'data.branding.subtitle' as Path<ReportDefinition>,
                value as LocalizedLabel,
                {
                  shouldDirty: true,
                },
              )
            }
            languages={languages}
          />
        </Box>

        <Box mt={2}>
          <HeaderBackgroundColorPicker />
        </Box>

        <LogoEditor />
      </Box>
    </Paper>
  );
}
